import React, { FunctionComponent } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import { SETTINGS_HEADER_HEIGHT } from '../AdminSettings/SettingsHeader';
import AdminSettingsContainer from './AdminSettingsContainer';
import AdminSettingsRoutes from './components/AdminUsers/AdminSettingsRoutes';

const StyledBodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    grid-column: 2 / 3;
    grid-row: 2 / 3;

    padding: 1rem;

    height: calc(100vh - ${SETTINGS_HEADER_HEIGHT});
    overflow: scroll;

    /* allows for a comfortable way to reach content thats at the very bottom of a page */
    padding-bottom: 10rem;
`;

// TODO: Update config to enums and update "any" types (rapid development mode)

/** For design: This controls the form components (radio, checkboxes, selects).  Current implementation: Case 1
 *  Case 1) Persist state between view changes: update `adminSettings` directly on any `onChange` event.
 *          This will keep user changes between view changes, but only update DB when the "SAVE" button is clicked.
 *  Case 2) Update state between view changes.  The user will lose changes between view changes (which would
 *          be a sort of stand-in 'reset' button).  We will need to fetch the data fresh each time, or keep a view-specific
 *          local state that re-initializes for each panel render.
 */

const SettingsBody: FunctionComponent = () => {
    const { initialLoad } = useContainer(AdminSettingsContainer);

    const { t } = useTranslation('admin_settings', { useSuspense: false });

    // TODO: I don't think design will like this solution 😳
    if (initialLoad) {
        return (
            <StyledBodyContainer>
                <Typography variant="body1">{t('body.loading')}</Typography>
            </StyledBodyContainer>
        );
    }

    return (
        <StyledBodyContainer>
            <AdminSettingsRoutes />
        </StyledBodyContainer>
    );
};

export default SettingsBody;
